import { render } from "./CommentReactionOptions.vue?vue&type=template&id=2432d862"
import script from "./CommentReactionOptions.vue?vue&type=script&lang=js"
export * from "./CommentReactionOptions.vue?vue&type=script&lang=js"
script.render = render

export default script